<template>
 <div id="duties-list">
  <div class="department-select">
    <p class="select-result">
      <span
          :class="{'open': open}"
          @click="selectorHandle"
      >{{ params.orgName && selectorObj.orgName != ''? params.orgName : '所属部门'}}</span></p>
    <DepartmentSelector
      v-if="open"
      :selectorObj='selectorObj'
      :list="orgArray"
      @selectedOrg = "selectedOrg"
      @selectedDepartment = "selectedDepartment"
      @fixedSelector="fixedSelector"
    ></DepartmentSelector>
  </div>
   <div class="duties-main" v-if="!emptyShow">
     <div class="duties-box" v-for="(item, index) in list" :key="index">
       <div class="duties" v-if="item.ZYZZ">
         <h4>主要职责</h4>
         <p>{{ item.ZYZZ }}</p>
       </div>
       <div
         :class="['duties-toggle', {'show' : openPanel && index == openIndex}, {'hide': !openPanel || index != openIndex}]"
         v-if="item.childData">
         <div class="duties">
           <h4>具体事项</h4>
           <p v-for="(jtem,idx) in item.childData" :key="idx">{{ idx + 1 }}.{{ jtem.ZZQDJTNR }}</p>
         </div>
         <div class="duties" v-if="item.XGYJ">
           <h4>制度依据</h4>
           <p>{{ item.XGYJ }}</p>
         </div>
       </div>
       <div class="duties-org">
         <van-icon class="left-icon iconfont" color="var(--main-color)" class-prefix="icon" name="homepage"></van-icon>
         <p class="org">生命科学学院</p>
         <van-icon
           :class="['right-icon', 'iconfont', {'open': openPanel && openIndex == index}]"
           class-prefix="icon"
           name="jiantou"
           @click="toggleHandle(index)"></van-icon>
       </div>
     </div>
   </div>
   <Error :type="'empty'" v-else></Error>
  <div class="dialog-bg" v-show="open"></div>
 </div>
</template>

<script>
import {queryMattersDepartments, queryMobileResponsibilityData} from '@/api/three-list/index'
import http from "@/utils/http";
import {Toast} from "vant";
export default {
  components: {
    DepartmentSelector: () => import('./components/DepartmentSelector')
  },
  data() {
    return {
      open: false,
      openPanel: false,
      openIndex: -1,
      params:{
        orgId: '',//部门id
        orgName: '',
      },
      selectorObj: {
        orgSelector: 1,
        selectId: '',
        departmentSelector: {}
      },
      orgArray:[],
      list: [],
      emptyShow: false
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getDectionary();
    },
    // 搜索
    searchHandle() {
      this.getList();
    },
    // 获取列表数据
    getList() {
      this.mixinShowLoading();
      this.emptyShow = false;
      queryMobileResponsibilityData({orgId: this.params.orgId}).then(res => {
        if (res.code && res.code == 200) {
          this.list = res.data;
          this.list.length > 0? this.emptyShow = false : this.emptyShow = true;
          this.mixinClearLoading();
        }
      })
    },
    // 机构点击赋值
    selectedOrg(val) {
      this.selectorObj.orgSelector = val;
    },
    // 部门点击赋值
    selectedDepartment(val) {
      this.selectorObj.departmentSelector = val;
      this.params.orgId = this.selectorObj.departmentSelector? this.selectorObj.departmentSelector.ORGID : '';
      this.params.orgName = this.selectorObj.departmentSelector? this.selectorObj.departmentSelector.ORGNAME : '';
    },
    // 部门选择赋值调用
    fixedSelector() {
      this.params.orgId = this.selectorObj.departmentSelector.ORGID;
      this.open = false;
      this.getList();
    },
    selectorHandle() {
      this.open = !this.open;
    },
    // 收起打开面板
    toggleHandle(index) {
      if(this.openIndex == index) {
        this.openPanel = !this.openPanel;
      } else {
        this.openPanel = true;
        this.openIndex = index;
      }
    },
    //  获取数据字典
    getDectionary() {
      const keys = [
        'listOrgType'//部门类别
      ];
      http.get('/param/keys.htm', {keys: keys.join()}).then(resp=>{
        if (!resp || resp.code != 200) {
          Toast(`获取系统参数${dictionaryKey}失败`)
        } else {
          let array = [];
          if (typeof resp.data['listOrgType'] == 'string') {
            array = JSON.parse(resp.data['listOrgType'])
          } else {
            array = resp.data['listOrgType']
          }
          this.orgArray = array;
          array.forEach((item, index) => {
            queryMattersDepartments({typeId: item.id}).then(res => {
              if(res.code && res.code == 200) {
                this.$set(this.orgArray[index], 'list', res.data || []);
                this.selectorObj.orgSelector = item;
                if(this.orgArray[index].list.length > 0) {
                  this.selectorObj.departmentSelector = this.orgArray[0].list[0];
                  this.params.orgId = this.selectorObj.departmentSelector.ORGID;
                  this.params.orgName = this.selectorObj.departmentSelector.ORGNAME;
                  this.getList();
                  return
                }
              }
            })
          })
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/theme/theme.scss";
#duties-list{
  padding-top: 60px;
  &:after{
    content: "";
    display: inline-block;
    width: 750px;
    height: 750px;
    background: var(--main-color);
    border-radius: 50%;
    position: absolute;
    top: -584px;
    left: -187px;
    z-index: 0;
  }
}
.department-select{
  height: 49px;
  box-sizing: border-box;
  padding:10px 15px;
  border-bottom: 1px solid #fff;
  background: var(--main-color);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1000;
  .select-result{
    width: 25%;
    height: 28px;
    line-height: 28px;
    box-sizing: border-box;
    padding: 0 8px;
    @extend .font14;
    position: relative;
    span{
      display: inline-block;
      width: 100%;
      height: 28px;
      line-height: 28px;
      padding-right: 12px;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #fff;
      &:after{
        content: "";
        display: inline-block;
        border: 4px solid transparent;
        border-bottom: 4px solid #fff;
        position: absolute;
        right: 0;
        top: 50%;
        transform: rotate(180deg);
        margin-top: -2px;
      }
      &.open:after{
        transform: rotate(0deg);
        margin-top: -9px;
      }
    }
  }
}
.duties-main{
  position: relative;
  z-index:1;
  margin: 0 15px;
  .duties-box{
    padding: 15px 0 0;
    background: #fff;
    border-radius: 5px;
    margin-bottom: 15px;
    .duties{
      @extend .font14;
      h4{
        height:35px;
        line-height: 35px;
        padding: 0 20px;
        position: relative;
        @extend .font16;
        @extend .color333;
        &:after{
          content: '';
          display: inline-block;
          width: 3px;
          height: 50%;
          background: var(--main-color);
          position: absolute;
          top: 25%;
          left: 0;
        }
      }
      p{
        line-height: 25px;
        padding: 0 15px;
      }
    }
    .duties-toggle{
      display: none;
      &.show{
        display: block;
      }
      &.hide{
        display: none;
      }
    }
    .duties-org{
      height: 35px;
      line-height: 35px;
      margin: 0 15px;
      padding:0 18px;
      border-top: 1px solid #e5e5e5;
      @extend .font14;
      position: relative;
      .iconfont{
        @extend .font14;
        position: absolute;
        top: 0px;
        &.left-icon{
          left: 0;
        }
        &.right-icon{
          right: 0;
          transform: rotate(90deg);
          color: #999;
          &.open{
            transform: rotate(-90deg);
          }
        }
      }
      p{
        height: 35px;
        color: #999;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
.dialog-bg{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, .7);
}
.empty{
  margin-top:120px;
  position: relative;
  z-index: 3;
}
</style>